import { Injectable } from "@angular/core";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";

@Injectable()
export class ExcelService {
  readonly #EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  readonly #EXCEL_EXTENSION = ".xlsx";

  /**
   * Converts the json param to 'excel' file and triggers the browser save window.
   * @param json {@link Array} object to save as excel
   * @param excelFileName {@link string} file name without extension.
   */
  exportAsExcelFile<T>(json: T[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
    const writeOptions: XLSX.WritingOptions = { bookType: "xlsx", type: "array" };
    const excelBuffer = XLSX.write(workbook, writeOptions);

    const blob: Blob = new Blob([excelBuffer], { type: this.#EXCEL_TYPE });
    FileSaver.saveAs(blob, excelFileName + "_export_" + new Date().getTime() + this.#EXCEL_EXTENSION);
  }
}
